import type { ReactNode } from 'react'
import type { DeskScreen } from '../lib/desk'

const Icon = ({ children }: { children: ReactNode }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">{children}</svg>
)

const ICON: Record<DeskScreen | 'ask', ReactNode> = {
  year: <Icon><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18M8 2v4M16 2v4" /></Icon>,
  browse: <Icon><rect x="3" y="4" width="8" height="7" rx="1" /><path d="M14 5h7M14 9h7M3 15h18M3 19h12" /></Icon>,
  lists: <Icon><path d="M9 6h11M9 12h11M9 18h11" /><circle cx="4.5" cy="6" r="1.2" /><circle cx="4.5" cy="12" r="1.2" /><circle cx="4.5" cy="18" r="1.2" /></Icon>,
  health: <Icon><path d="M3 12h4l3-7 4 14 3-7h4" /></Icon>,
  account: <Icon><circle cx="12" cy="8" r="4" /><path d="M4 21c1-4 4-6 8-6s7 2 8 6" /></Icon>,
  ask: <Icon><path d="M4 5h16v11H9l-5 4z" /></Icon>,
}

const LABEL: Record<DeskScreen | 'ask', string> = {
  year: 'Year', browse: 'Browse', lists: 'Lists', health: 'Health', account: 'Account', ask: 'Ask',
}

export function Rail({ screens, current, showDot, askOpen, onNav, onAsk }: {
  /** The entries above the fold, in order — `railScreens(isAdmin)`, so Health
   *  is there only for an admin (U0.3). */
  screens: readonly DeskScreen[]
  current: DeskScreen | null
  /** `App.tsx`'s `showDot`, passed down — not recomputed here. */
  showDot: boolean
  askOpen: boolean
  onNav: (s: DeskScreen) => void
  onAsk: () => void
}) {
  const item = (s: DeskScreen) => (
    <button key={s} type="button" aria-current={current === s ? 'page' : undefined}
      aria-label={LABEL[s]} title={LABEL[s]} onClick={() => onNav(s)}>
      {ICON[s]}
      <span className="label">{LABEL[s]}</span>
      {s === 'health' && showDot && <i className="dot" title="Open alerts" />}
    </button>
  )
  return (
    <nav className="desk-rail" aria-label="Screens">
      <div className="mark"><i aria-hidden="true" /><span>Kiez</span></div>
      {screens.map(item)}
      <div className="spacer" />
      <div className="foot">
        <button type="button" aria-pressed={askOpen} aria-label="Ask" title="Ask" onClick={onAsk}>
          {ICON.ask}<span className="label">Ask</span>
        </button>
        {item('account')}
      </div>
    </nav>
  )
}
